<template>
  <div>
    <date-range
      :title="overviewTxt"
      :date-data="dateData"
      @dateCallback="handleDateChange"
    />
    <div class="distribute-content">
      <HChart
        :id="distributeId"
        ref="distributeRef"
        :option="distributeOption"
      />
    </div>
    <div class="statistic-detail">
      <div
        v-for="(items,indexs) in headStatusArray"
        :key="indexs"
      >
        <div
          v-if="items.name===reviewTit"
          class="normal-content"
        >
          <span class="bull-size red">&bull;</span><span class="text">{{ items.name }}</span><span class="persent">{{ items.per }}</span><span class="number">{{ items.num }}</span>
        </div>
        <div
          v-else-if="items.name===passTit"
          class="normal-content"
        >
          <span class="bull-size green">&bull;</span><span class="text">{{ items.name }}</span><span class="persent">{{ items.per }}</span><span class="number">{{ items.num }}</span><i
            class=" margin-left-12 iconfont pointer"
            :class="rowDirection"
            @click="handleDFold"
          />
        </div>
        <div
          v-else
          class="normal-content"
        >
          <span class="bull-size yellow">&bull;</span><span class="text">{{ items.name }}</span><span class="persent">{{ items.per }}</span><span class="number">{{ items.num }}</span>
        </div>
        <div v-if="foldStatus&&items.name===LostOrderTit">
          <div
            v-for="(item,index) in headOtherArray"
            :key="index"
            class="second-content"
          >
            <span class="text2">{{ item.name }}</span><span class="persent2">{{ item.per }}</span><span class="number2">{{ item.num }}</span>
          </div>
        </div>
      </div>
      <cube-loading v-if="!headOtherArray.length" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import HChart from '@/components/pc/HighChart.vue'
import { mobileDistributePieOptions } from '@/lib/chart-option'
import { overviewIndex, formatePickerData, formatePieDatas } from '@/lib/statistic-utils'
import DateRange from './components/DateSelectComponents'
export default {
  components: {
    DateRange,
    HChart
  },
  data () {
    return {
      distributeId: 'distributeId',
      distributeOption: mobileDistributePieOptions(),
      foldStatus: false,
      dateData: formatePickerData(overviewIndex),
      rowDirection: 'iconicon-test17',
      overviewTimeData: { timetype: 1 },
      headStatusArray: [],
      headOtherArray: []
    }
  },
  computed: {
    ...mapState('statistic', ['indexHeadDatas']),
    reviewTit () {
      return this.$t('message["143"]')
    },
    overviewTxt () {
      return this.$t('message["293"]')
    },
    LostOrderTit () {
      return this.$t('message["1690"]')
    },
    passTit () {
      return this.$t('message["1206"]')
    }
  },
  watch: {
    indexHeadDatas (val) {
      if (!val) return
      this.drawPie(formatePieDatas(val))
      this.headOtherArray = val.other
      this.headStatusArray = val.status
      document.title = this.$t('message["1671"]') + `-${this.$store.state.baseinfo.projectname}-${this.$store.state.baseinfo.comname}`
    }
  },
  mounted () {
    this.fetchGetIndexHeadDatas(this.overviewTimeData)
  },
  methods: {
    ...mapActions('statistic', ['fetchGetIndexHeadDatas']),
    handleDFold () {
      if (this.rowDirection === 'iconicon-test17') {
        this.foldStatus = true
        this.rowDirection = 'iconicon-test14'
      } else {
        this.foldStatus = false
        this.rowDirection = 'iconicon-test17'
      }
    },
    drawPie (json) {
      this.$refs.distributeRef.chartObj.title.update({ text: `<p style="font-size: 14px;color:#666666;text-align:center">${json.total.name}</p><p style=" font-family: Roboto;font-size: 48px;text-align:center;color: #333333;">${json.total.num}</p>` })
      this.$refs.distributeRef.chartObj.series[0].update({
        type: 'pie',
        innerSize: '80%',
        name: this.$t('message["1374"]'),
        data: json.data
      })
    },
    handleDateChange (value) {
      if (value.value === -1) {
        const {
          starttime, endtime
        } = value.time
        delete this.overviewTimeData.timetype
        this.overviewTimeData.starttime = starttime
        this.overviewTimeData.endtime = endtime
      } else {
        delete this.overviewTimeData.starttime
        delete this.overviewTimeData.endtime
        this.overviewTimeData.timetype = value.value
      }
      this.fetchGetIndexHeadDatas(this.overviewTimeData)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
